const currencyList = [
    {value: 'gbp', label: 'GBP - £'},
    {value: 'usd', label: 'USD - $'},
    {value: 'eur', label: 'EUR - €'}
]

export {currencyList}